export class Question {
    question_id;
    question_file;
    question_text;
    response_duration;
    question_wrapper_id: string;
    selected: any;
    constructor(question_id, question_file, question_text, response_duration) {
        this.question_id = question_id;
        this.question_file = question_file;
        this.question_text = question_text;
        this.response_duration = response_duration;

    }
}
